import React, { useEffect, useRef } from 'react';
import { FiTrash2 } from 'react-icons/fi';

const DepositSignaturePad = ({ label, value, onChange }) => {
  const canvasRef = useRef(null);
  const drawingRef = useRef(false);
  const loadedValueRef = useRef('');
  useEffect(() => {
    if (!value && loadedValueRef.current) {
      const canvas = canvasRef.current;
      canvas.getContext('2d').clearRect(0, 0, canvas.width, canvas.height);
    }
    loadedValueRef.current = value || '';
    if (!value) return undefined;
    let cancelled = false;
    const image = new Image();
    image.onload = () => {
      if (cancelled) return;
      const canvas = canvasRef.current;
      const context = canvas.getContext('2d');
      context.clearRect(0, 0, canvas.width, canvas.height);
      context.drawImage(image, 0, 0, canvas.width, canvas.height);
    };
    image.src = value;
    return () => { cancelled = true; };
  }, [value]);
  const point = (event) => {
    const canvas = canvasRef.current;
    const rect = canvas.getBoundingClientRect();
    return [(event.clientX - rect.left) * canvas.width / rect.width, (event.clientY - rect.top) * canvas.height / rect.height];
  };
  const finish = () => {
    if (!drawingRef.current) return;
    drawingRef.current = false;
    onChange(canvasRef.current.toDataURL('image/png'));
  };
  return <div>
    <span>{label}</span>
    <canvas ref={canvasRef} width={900} height={240} className="deposit-signature-canvas" aria-label={label}
      onPointerDown={(event) => {
        if (event.button !== 0 || drawingRef.current) return;
        event.preventDefault();
        const canvas = canvasRef.current;
        canvas.setPointerCapture?.(event.pointerId);
        const context = canvas.getContext('2d');
        context.strokeStyle = '#152840';
        context.lineWidth = 3;
        context.lineCap = 'round';
        context.lineJoin = 'round';
        context.beginPath();
        const [x, y] = point(event);
        context.moveTo(x, y);
        context.lineTo(x + 0.1, y + 0.1);
        context.stroke();
        drawingRef.current = true;
      }}
      onPointerMove={(event) => {
        if (!drawingRef.current) return;
        const context = canvasRef.current.getContext('2d');
        context.lineTo(...point(event));
        context.stroke();
      }}
      onPointerUp={finish} onPointerCancel={finish} onLostPointerCapture={finish}
    />
    <small>Ký bằng chuột hoặc chạm tay; chữ ký sẽ xuất hiện ở mặt sau hợp đồng.</small>
    <button type="button" className="btn btn-neutral btn-sm" onClick={() => {
      drawingRef.current = false;
      const canvas = canvasRef.current;
      canvas.getContext('2d').clearRect(0, 0, canvas.width, canvas.height);
      onChange('');
    }}><FiTrash2 size={13} /> Xóa chữ ký</button>
  </div>;
};

export default DepositSignaturePad;
